import React from 'react';
import { partnerLogosMap } from '../../../../static/logos/PartnerLogos';  // Adjust the import path as needed
import './Partner.css'; 

const PartnerComponent = () => {
    return (
        <div className="partners">
            <h2>PARTNER</h2>
            <div className="partners__content">
                {Object.keys(partnerLogosMap).map((partner) => (
                    <div key={partner} className="partners__logo">
                        <img
                            src={partnerLogosMap[partner]}
                            alt={`{partner} Logo`}
                            className={partner}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PartnerComponent;  // Make sure to export the component
